export default "__VITE_ASSET__f23f8e74__"